<template>
    <v-container>
        <v-navigation-drawer v-model="drawer" :clipped="$vuetify.breakpoint.lgAndUp" temporary app>
            <v-layout column mt-5>
                <v-flex subtitle-1 px-5 pb-3 v-if="user" class="font-weight-black">{{ user.cliStrNme }}</v-flex>
            </v-layout>

            <v-list class="pt-0">
                <v-divider></v-divider>

                <v-list-item router :key="i" v-for="(item, i) in items()" :href="to(item.to)" exact>
                    <v-list-item-action>
                        <v-icon v-html="item.icon"></v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title v-text="item.text" class="subtitle-2"></v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                    <v-btn text color="grey" @click.native.stop="login" v-if="!user">
                        <v-icon medium class="mr-7">las la-user-circle</v-icon>Login
                    </v-btn>
                </v-list-item>
                <v-list-item>
                    <v-btn text color="grey" @click.native.stop="logout" v-if="user">
                        <v-icon medium class="mr-7">las la-power-off</v-icon>Logout
                    </v-btn>
                </v-list-item>
            </v-list>

            <v-layout align-center justify-center column mt-5 v-if="!inicio()">
                <v-flex subtitle-2 px-5 v-if="funcionarioResponsavel">
                    Seu consultor é
                    {{ funcionarioResponsavel.funStrNme | capitalize }}
                </v-flex>
            </v-layout>
            <v-layout align-center justify-center column>
                <img :src="empresa.empStrLogoPath" width="100%" height="100%" v-if="empresa" class="pa-4 contain" />
            </v-layout>
        </v-navigation-drawer>

        <v-app-bar fixed color="var(--vs-azul-primaria)" light elevation="0" height="64"
            style="border-bottom: 0.5px solid var(--vs-marrom-secundario) !important;">
            <!-- Menu hamburguer e chame o vendedor -->
            <v-toolbar-title style="width: 300px" class="ml-0 pl-3 grey--text">
                <v-app-bar-nav-icon @click.stop="drawer = !drawer" dark v-if="anuncio()"></v-app-bar-nav-icon>
                <span class="font-weight-black blue--text text--lighten-4">
                    <a :href="anuncio()" @click="zeraPesquisa()">
                        <img class="shrink hidden-sm-and-down" contain src="../assets/logotipo_chame.png" width="200" />
                    </a>
                </span>
            </v-toolbar-title>

            <!-- Campo pesquisar -->
            <v-form @submit.prevent="pesquisar">
                <v-card color="white" style="width: 500px !important; height: 70%"
                    class="campo-pesquisa-round hidden-sm-and-down">
                    <v-text-field v-model="search" icon icon-after
                        placeholder="Pesquisar por código da peça, nome, veiculo, ano..." type="search"
                        v-if="!campoPesquisa()" class="pl-4 pr-4 pesquisa" color="var(--vs-marrom-secundario)" hide-details
                        single-line>
                        <v-icon slot="append" color="black" @click="pesquisar()">las la-search</v-icon>
                    </v-text-field>
                </v-card>
            </v-form>

            <v-card color="white" style="width: 60% !important; height: 70%"
                class="bigger campo-pesquisa-round hidden-md-and-up" v-if="user && !campoPesquisa()">
                <v-text-field v-model="search" icon icon-after placeholder="Pesquisar" type="search" v-if="!campoPesquisa()"
                    class="pl-4 pr-4 pesquisa" color="var(--vs-marrom-secundario)" hide-details single-line>
                    <v-icon slot="append" color="black" class="pt-1" @click="pesquisar()">las la-search</v-icon>
                </v-text-field>
            </v-card>

            <v-spacer></v-spacer>

            <!-- Nome da empresa canto direito -->
            <v-layout align-center justify-center>
                <v-flex v-if="!inicio() && empresa" body-2 px-5
                    class="grey--text text-right font-weight-black hidden-sm-and-down pa-0 pt-5">{{
                        empresa.empStrNmeFantasia }}</v-flex>
            </v-layout>

            <!-- Botão carrinho -->
            <v-badge color="var(--vs-vermelho)" overlap v-if="!inicio()" class="align-self-end pb-1">
                <template v-slot:badge>
                    <span style="margin-bottom: 1px !important;">
                        {{
                            contadorCarrinho
                        }}
                    </span>
                </template>

                <vs-button circle style="min-width: 70px;" color="warning" animation-type="scale"
                    @click.native.stop="carrinho">
                    <i class="las la-shopping-cart" style="font-size: 20px !important"></i>
                    <template #animate>Carrinho</template>
                </vs-button>
                <template #tooltip>Carrinho de compras</template>
            </v-badge>

        </v-app-bar>
        <MenuCatalogoItens />
    </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import Alert from "../utils/alert";
import Constantes from "../utils/constantes";
import MenuCatalogoItens from "./MenuCatalogoItens.vue";

export default {
    data: () => ({
        search: "",
        URL_SERVIDOR: Constantes.URL_SERVIDOR,
        dialog: false,
        drawer: null,
        loadingPesquisar: null,
        itensMenu: []
    }),
    methods: {
        items() {
            let items = [];
            if (this.user) {
                items = [
                    {
                        icon: "las la-tag",
                        text: "Ofertas",
                        to: `/${this.$route.params.id}/anuncio`,
                    },
                    {
                        icon: "las la-shopping-cart",
                        text: "Pedidos",
                        to: `/${this.$route.params.id}/pedidos`,
                    },
                    {
                        icon: "las la-file-invoice",
                        text: "Meus Dados",
                        to: `/${this.$route.params.id}/meusdados`,
                    },
                    {
                        icon: "las la-map-marked-alt",
                        text: "Localizar Concessionária",
                        to: `/${this.$route.params.id}/concessionariaproxima`,
                    },
                    {
                        icon: "las la-lock",
                        text: "Trocar Senha",
                        to: `/${this.$route.params.id}/trocarsenha`,
                    },
                ];
            }
            else {
                items = [
                    {
                        icon: "las la-tag",
                        text: "Ofertas",
                        to: `/${this.$route.params.id}/anuncio`,
                    },
                ];
            }
            return items;
        },
        logout() {
            this.$store.dispatch("cliente/logout");
            this.$router.push({ name: "login" });
        },
        home() {
            this.$router.push({ name: "home" });
        },
        carrinho() {
            this.$router.push({ name: "carrinho" });
        },
        zeraPesquisa() {
            this.$store.dispatch("search/pesquisar", "");
        },
        anuncio() {
            if (this.$route.params.id) {
                return `/${this.$route.params.id}/anuncio`;
            }
        },
        to(h) {
            if (h) {
                return h;
            }
            else {
                return false;
            }
        },
        inicio() {
            return (this.$router.currentRoute.name === "login" ||
                this.$router.currentRoute.name === "registro" ||
                this.$router.currentRoute.name === "home");
        },
        campoPesquisa() {
            return (this.$router.currentRoute.name === "carrinho" ||
                this.$router.currentRoute.name === "home" ||
                this.$router.currentRoute.name === "login" ||
                this.$router.currentRoute.name === "pedido" ||
                this.$router.currentRoute.name === "pedidos" ||
                this.$router.currentRoute.name === "registro" ||
                this.$router.currentRoute.name === "trocarsenha" ||
                this.$router.currentRoute.name === "finalizarpedido" ||
                this.$router.currentRoute.name === "meusdados");
        },
        login() {
            this.$router.push({ name: "login" });
        },
        pesquisar() {
            if (this.search) {
                if (this.search.length >= 4) {
                    this.$store.commit("anuncio/setDestaques", null);
                    this.handleClickLoading("waves");
                    let obj = {};
                    obj.texto = this.search;
                    obj.empIntCod = this.empresa.empIntCod;
                    if (this.user) {
                        obj.cliIntCod = this.user.cliIntCod;
                    }
                    else {
                        obj.cliIntCod = "";
                    }
                    this.$store.commit("anuncio/limparAnuncios");
                    this.$store
                        .dispatch("anuncio/pesquisar", obj)
                        .then(() => {
                            this.hideLoading();
                        })
                        .catch(() => {
                            this.hideLoading();
                        });
                }
            }
            else {
                this.$store.dispatch("anuncio/carregarDestaques", {
                    empIntCod: this.$route.params.id,
                });
                this.handleClickLoading("waves");
                this.$store.commit("anuncio/limparAnuncios");
                this.$store
                    .dispatch("anuncio/carregarAnuncios", {
                        empIntCod: this.$route.params.id,
                        ancIntCod: -1,
                    })
                    .then(() => {
                        this.hideLoading();
                    })
                    .catch(() => {
                        this.hideLoading();
                    });
            }
        },
        handleClickLoading(type) {
            this.loadingPesquisar = this.$vs.loading({
                type,
            });
        },
        hideLoading() {
            this.loadingPesquisar.close();
        },
        dispatch() { },
        async carregarCategorias() {
            const url = `${Constantes.URL_SERVIDOR}/catalogo/itens-menu?empIntCod=${this.$route.params.id}`;

            try {
                const response = await axios.get(url);
                this.menu = response.data;

                this.itensMenu = this.createItensMenu(this.menu, null, 1);
                this.insertEstrutura();
            } catch (error) {
                console.error('Erro ao carregar categorias:', error);
            }
        }
    },
    computed: {
        ...mapGetters({
            user: "cliente/user",
            empresa: "anuncio/empresa",
            token: "cliente/token",
            contadorCarrinho: "pedido/contadorCarrinho",
            error: "core/error",
            success: "core/success",
            loading: "core/loading",
            funcionarioResponsavel: "cliente/funcionarioResponsavel",
            menu: "cliente/menu",

        }),
    },
    watch: {
        error(value) {
            if (value) {
                let { error, status, message } = value;
                if (status !== undefined) {
                    if (status === 403) {
                        this.logout();
                    }
                }
                else {
                    if (message.includes("403")) {
                        this.logout();
                    }
                }
                this.$store.dispatch("core/clearError");
            }
        },
        success(value) {
            if (value) {
                Alert.success(value.title, value.message);
                this.$store.dispatch("core/clearSuccess");
            }
        },
        search(val) {
            this.$store.dispatch("search/pesquisar", val);
            if (this.search === "") {
                this.$store.dispatch("search/pesquisar", "");
                this.handleClickLoading("waves");
                this.$store
                    .dispatch("anuncio/carregarAnuncios", {
                        empIntCod: this.$route.params.id,
                        ancIntCod: -1,
                    })
                    .then(() => {
                        this.hideLoading();
                    })
                    .catch(() => {
                        this.hideLoading();
                    });
            }
        },
    },
    components: { MenuCatalogoItens }
};
</script>

<style scoped>
.default {
    transition: max-height 0.25s ease-out;
    width: 20px;
    transition-property: width;
}

.bigger {
    transition: max-height 0.25s ease-out;
    width: 150px;
    transition-duration: 0.5s;
    transition-property: width;
}

.campo-pesquisa-round {
    border-radius: 12px !important;
}

input:-internal-autofill-selected {
    background-color: transparent !important;
}
</style>
